const c = "_content_1c89p_2", l = "_clickable_1c89p_12", t = "_label_1c89p_17", e = {
  content: c,
  clickable: l,
  label: t
};
export {
  l as clickable,
  c as content,
  e as default,
  t as label
};
//# sourceMappingURL=index.es5600.js.map
